/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 03.05.13, 10:02
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
export class ABTestLPDataConstants {
    public static TEST_ID: string = "tid";
    public static TEST_ID_DEFAULT_VALUE: string = "0";

    public static CASE_ID: string = "cid";
    public static CASE_ID_DEFAULT_VALUE: string = "0";
}
